import { useEffect, useState } from "react";
import { useActiveWallet } from "thirdweb/react";

export type WalletKind = "metamask" | "inapp" | "walletconnect" | "other" | null;

export function useWalletKind(): WalletKind {
  const wallet = useActiveWallet();
  const [kind, setKind] = useState<WalletKind>(null);

  useEffect(() => {
    let ignore = false;
    (async () => {
      if (!wallet) {
        if (!ignore) setKind(null);
        return;
      }

      // 1) Prefer the wallet's id (most reliable & available)
      const info = (wallet as any)?.getWalletInfo?.();
      const id = (wallet as any).id ?? (wallet as any)?.walletId ?? info?.id;
      const idL = String(id ?? "").toLowerCase();

      if (idL.includes("inapp")) {
        if (!ignore) setKind("inapp");
        return;
      } else if (idL.includes("metamask")) {
        if (!ignore) setKind("metamask");
        return;
      } else if (idL.includes("walletconnect")) {
        if (!ignore) setKind("walletconnect");
        return;
      }

      try {
        // 2) Fallback: check provider flags
        const provider =
          (await (wallet as any).getEthereumProvider?.()) ||
          (wallet as any)?.provider ||
          null;
        if (provider?.isMetaMask) {
          if (!ignore) setKind("metamask");
          return;
        }
      } catch {
        // fall through to personal wallet checks
      }

      try {
        // 3) Underlying personal wallet (for smart/account abstraction wrappers)
        const personal = await (wallet as any).getPersonalWallet?.();
        if (personal) {
          const pInfo = personal?.getWalletInfo?.();
          const pId = personal?.id ?? personal?.walletId ?? pInfo?.id;
          const pIdL = String(pId ?? "").toLowerCase();
          if (pIdL.includes("metamask")) {
            if (!ignore) setKind("metamask");
            return;
          }
          
          const pProvider =
            (await personal?.getEthereumProvider?.()) ||
            (personal as any)?.provider ||
            null;
          if (pProvider?.isMetaMask) {
            if (!ignore) setKind("metamask");
            return;
          }
        }
      } catch {
        // ignore
      }

      if (!ignore) setKind("other");
    })();
    return () => {
      ignore = true;
    };
  }, [wallet]);

  return kind;
}


